import { render } from "./category.vue?vue&type=template&id=eca268dc&scoped=true&ts=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"

import "./category.vue?vue&type=style&index=0&id=eca268dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca268dc"]])

export default __exports__